import React, { Component } from 'react';
import { List, Avatar, message, Icon, Input, Button, Tag, Select, DatePicker, Menu, Dropdown, Pagination } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import VisitKindModal from '../../components/modals/VisitKindModal';
import axios from 'axios';
import Configuration from '../../Configuration';
import openSocket from 'socket.io-client';
const Search = Input.Search;
const Option = Select.Option;
const SubMenu = Menu.SubMenu;
const socket = openSocket(Configuration.wsServer);

class VisitsEmployee extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, visits: [], filteredVisits: [], visitKindModal: false, employees: [], startDate: '', endDate: '', employee: '', total: 0};
    this.validateToken = this.validateToken.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getVisits = this.getVisits.bind(this);
    this.appendVisit = this.appendVisit.bind(this);
    this.removeVisit = this.removeVisit.bind(this);
    this.getEmployees = this.getEmployees.bind(this);
    this.handleFilterEmployee = this.handleFilterEmployee.bind(this);
    this.handleFilterStartDate = this.handleFilterStartDate.bind(this);
    this.handleFilterEndDate = this.handleFilterEndDate.bind(this);
    this.visitMenu = this.visitMenu.bind(this);
    this.handleAuthorize = this.handleAuthorize.bind(this);
    this.handleDeny = this.handleDeny.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.changePage = this.changePage.bind(this);
    // WS
    // New employee access
    socket.on(`new-visit-${localStorage.getItem('visitapp:company')}-${localStorage.getItem('visitapp:employee_id')}-employee-access`, visit => {
      this.appendVisit(visit.visit_id);
    });
    // New employee visit
    socket.on(`new-visit-${localStorage.getItem('visitapp:company')}-employee-${localStorage.getItem('visitapp:id')}`, visit => { 
      this.appendVisit(visit.visit_id);
    });
    // Arrive visit
    socket.on(`arrive-visit-${localStorage.getItem('visitapp:company')}-${localStorage.getItem('visitapp:employee_id')}`, visit => { 
      this.removeVisit(visit.visit_id);
      this.appendVisit(visit.visit_id);
    });
    // Enter visit
    socket.on(`enter-visit-${localStorage.getItem('visitapp:company')}-${localStorage.getItem('visitapp:employee_id')}`, visit => { 
      this.removeVisit(visit.visit_id);
      this.appendVisit(visit.visit_id);
    });
    // Reception visit
    socket.on(`reception-visit-${localStorage.getItem('visitapp:company')}-${localStorage.getItem('visitapp:employee_id')}`, visit => { 
      this.removeVisit(visit.visit_id);
      this.appendVisit(visit.visit_id);
    });
    // Leave visit
    socket.on(`leave-visit-${localStorage.getItem('visitapp:company')}-${localStorage.getItem('visitapp:employee_id')}`, visit => { 
      this.removeVisit(visit.visit_id);
      this.appendVisit(visit.visit_id);
    });
  }

  componentDidMount() {
    this.validateToken();
    this.getVisits(1);
    this.getEmployees();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});

    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getVisits(page) {
    let url = `${Configuration.apiServer}/api/v1/employee-visits?page=${page}`;
    if(this.state.employee !== 'undefined' && this.state.employee !== '')
      url += `&employee=${this.state.employee}`;

    if(this.state.startDate !== '' && this.state.endDate !== '')
      url += `&start=${this.state.startDate}&end=${this.state.endDate}`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.setState({visits: resp.data.visits, filteredVisits: resp.data.visits, total: resp.data.total});
    });
  }

  changePage(value) {
    this.getVisits(value);
  }

  appendVisit(id) {
    let url = `${Configuration.apiServer}/api/v1/visits/${id}`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al añadir una visita nueva');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      // Append visits to state
      let visits = this.state.visits;
      visits.unshift(resp.data);
      this.setState({visits: visits, filteredVisits: visits});
    });
  }

  removeVisit(id) {
    let visitIndex = 0;
    let visitFilterIndex = 0;
    let visits = this.state.visits;
    let filteredVisits = this.state.filteredVisits;

    this.state.visits.forEach((visit, index) => {
      // eslint-disable-next-line
      if(parseInt(visit.id) === parseInt(id))
        visitIndex = index;
    });
    this.state.filteredVisits.forEach((visit, index) => {
      // eslint-disable-next-line
      if(parseInt(visit.id) === parseInt(id))
        visitFilterIndex = index;
    });

    visits.splice(visitIndex, 1);
    filteredVisits.splice(visitFilterIndex, 1);
    this.setState({visits: visits, filteredVisits: filteredVisits});
  }

  getEmployees() {
    axios.get(`${Configuration.apiServer}/api/v1/profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      this.setState({employees: resp.data});
    });
  }

  handleAuthorize(visit) {
    axios.put(`${Configuration.apiServer}/api/v1/visits/${visit.id}/authorize`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro actualizado');
      this.getVisits(1);
    });
  }

  handleDeny(visit) {
    axios.put(`${Configuration.apiServer}/api/v1/visits/${visit.id}/deny`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro actualizado');
      this.getVisits(1);
    });
  }

  handleDelete(visit) {
    axios.delete(`${Configuration.apiServer}/api/v1/visits/${visit.id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro eliminado');
      this.getVisits(1);
    });
  }

  handleFilterEmployee(value) {
    this.setState({employee: value});
  }

  handleFilterStartDate(value) {
    if(value)
      this.setState({startDate: value.format('YYYY-MM-DD')});
  }

  handleFilterEndDate(value) {
    if(value)
      this.setState({endDate: value.format('YYYY-MM-DD')});
  }

  handleSearch(event) {
    const visits = this.state.visits.filter(visit => {
      return visit.subject.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredVisits: visits});
  }

  handleOpenModal() {
    this.setState({visitKindModal: true});
  }

  handleCloseModal() {
    this.setState({visitKindModal: false});
  }

  visitMenu(visit) {
    let submenus = [<Menu.Item key="visit:show"><a href={`/visits/${visit.id}`}>Ver visita</a></Menu.Item>];
    
    // eslint-disable-next-line
    if(parseInt(localStorage.getItem('visitapp:id')) === parseInt(visit.profile_id)) {
      if(visit.status === 'pending' && !visit.quick)
        submenus.push(
          <SubMenu title="Gestionar" key="visit:admin">
            <Menu.Item><span onClick={ () => { this.handleDelete(visit) } }>Borrar</span></Menu.Item>
          </SubMenu>
        );

      if(visit.status === 'pending' && visit.quick)
        submenus.push(
          <SubMenu title="Autorización" key="visit:authorization">
            <Menu.Item><span onClick={ () => { this.handleAuthorize(visit) } }>Autorizar</span></Menu.Item>
            <Menu.Item><span onClick={ () => { this.handleDeny(visit) } }>Negar</span></Menu.Item>
          </SubMenu>
        );
    }

    return (<Menu>{submenus}</Menu>);
  }

  getVisitVisitors(visit) {
    let visitors = [];

    if('visitors' in visit) {
      visit.visitors.forEach(visitor => {
        visitors.push(<Tag color="purple" key={`visitor:${visitor.id}`}><Icon type="team" /> {visitor.name}</Tag>);
      });
    }

    return visitors;
  }
 
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }
    // Get employee options
    const employeeOptions = this.state.employees.map(employee => {
      return (
        <Option value={employee.id} key={`employee:${employee.id}`}>{employee.names}</Option>
      );
    });

    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Visitas por empleados</h3>

            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%'}} />
          </div>

          <div className="d-flex justify-content-between align-items-center" style={{ background: '#f1f1f1', margin: '30px 0px', padding: '20px', borderRadius: '5px' }}>
            <DatePicker onChange={this.handleFilterStartDate} style={{ width: '25%' }} />
            <DatePicker onChange={this.handleFilterEndDate} style={{ width: '25%' }} />
            <Select
              showSearch
              style={{ width: '35%' }}
              placeholder="Elige un empleado"
              optionFilterProp="children"
              onChange={this.handleFilterEmployee}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              <Option value="" key="employee:0">Todas</Option>
              {employeeOptions}
            </Select>
            <Button icon="search" type="primary" shape="circle" onClick={() => { this.getVisits(1) }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <List
              className="demo-loadmore-list"
              itemLayout="vertical"
              style={{ width: '100%' }}
              dataSource={this.state.filteredVisits}
              renderItem={visit => (
                <List.Item>
                  <div className="d-flex align-items-center justify-content-between">                    
                    <div style={{ width: '90%' }}>
                      <h6 className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                        <span>{visit.subject}</span> 
                        <div>
                          {(visit.quick) ? <Tag color="geekblue">Rápida</Tag> : ''}
                          <Tag color="cyan">{Configuration.formatDatetime(visit.due_date)}</Tag>
                          <Tag color={Configuration.getVisitStatus(visit.status).color}>{Configuration.getVisitStatus(visit.status).text}</Tag>
                        </div>
                      </h6>
                      <p style={{ marginBottom: '0px' }}>
                        <span style={{ marginRight: '10px' }}>Folio: #{visit.folio}</span>
                        <span>Detalles: {(visit.details) ? visit.details : 'Sin detalles'}</span>
                      </p>
                    </div>

                    <Dropdown overlay={this.visitMenu(visit)}>
                      <span className="ant-dropdown-link">
                        <Button icon="ellipsis" shape="circle" style={{ background: '#eee' }} />
                      </span>
                    </Dropdown>
                  </div>

                  <div style={{ width: '100%', marginTop: '20px'}}>
                    <Tag>
                      <Icon type="tag-o" /> {visit.visit_kind.kind.name} 
                    </Tag>
                    <Tag>
                      <Icon type="calendar" /> Creada {Configuration.formatDate(visit.created_at)}
                    </Tag>
                    <Tag>
                      <Icon type="clock-circle-o" /> Permanencia {(visit.status === 'leave') ? Configuration.stayTime(visit.access_date, visit.leave_date) : 0} min.
                    </Tag>
                    <Tag>
                      <Icon type="user" /> {visit.profile.names}
                    </Tag>
                  </div>

                  <div style={{ width: '100%', marginTop: '10px' }}>
                    {this.getVisitVisitors(visit)}
                  </div>
                </List.Item>
              )}
            />
          </div>

          <div className="text-center" style={{ margin: '20px 0px' }}>
            <Pagination defaultPageSize={20} total={this.state.total} onChange={this.changePage} />
          </div>

        </div>
          
        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />
        <VisitKindModal visible={this.state.visitKindModal} handleClose={this.handleCloseModal} service={true} employee={true} carrier={true} visitor={true} handleList={this.getVisits} />
      </div>
    );
  }
}

export default VisitsEmployee;



// WEBPACK FOOTER //
// ./src/pages/visits/VisitsEmployee.js